module.exports = __webpack_public_path__ + "img/logo-safras-white.68fe7257.svg";